import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const contract = {
  state: {
    regularContract: true,
    company: {
      name: "",
      cvr: "",
      address: "",
      phone: "",
    },
    drivingLicense: {
      number: "",
      expirationDate: "",
      a: false,
      b: false,
      c: false,
      d: false,
      e: false,
      be: false,
      ce: false,
      de: false,
    },
    education: {
      extended: false,
      extendedDescription: ""
    },
    employee: {
      name: "",
      address: "",
      cpr: "",
      municipality: "",
      phone: "",
      registrationNumber: "",
      bankAccount: "",
    },
    employmentDetails: {
      location: "",
      startingDate: "",
      endingDate: "",
      indefintie: false,
      temporary: false,
    },
    healthControl: {
      isEnabled: false,
    },
    holiday: {
      closed: false,
      granted: false,
      closedPeriod: "",
      grantedPeriod: "",
    },
    jobCategories: {
      driver: false,
      driverExtended: false,
      movingServices: false,
      exportDriver: false,
      renovation: false,
      other: false,
      otherDescription: "",
    },
    locale: {
      formLocale: "da-DK",
      contractLocale: "da-DK",
    },
    otherAbsence: {
      extendedRights: false,
      extendedRightsDescription: ""
    },
    pension: {
      optionOne: false,
      optionTwo: false,
      optionThree: false,
      optionTwoStartingDate: "",
      optionThreeFinalDate: "",
      companyContribution: "",
      employeeContribution: "",
    },
    qualifications: {
      vet: false,
      driverEuro: false,
      stacker: false,
      forklift: false,
      crane: false,
      other: false,
      adr: false,
      vub: false,
      vetDate: "",
      driverEuroExpirationDate: "",
      adrExpirationDate: "",
      vubExpirationDate: "",
      otherDescription: "",
    },
    salary: {
      amount: "",
    },
    special_saving: {
      savingPercent: "",
    },
    salaryPeriod: {
      payday: "",
    },
    sickness: {
      name: "",
      phone: "",
    },
    socialSecurityInstitutions: {
      workInsuranceCompany: '',
      otherSystems: false,
      otherSystemsDescription: ""
    },
    specialTerms: {
      sickness: false,
      sicknessText: "",
      alcohol: false,
      alcoholText: "",
      breaks: false,
      breaksDuration: "",
      gps: false,
      gpsText: "",
      speeding: false,
      speedingText: "",
      vanvidsbilisme: false,
      cleaning: false,
      smoking: false,
      other: false,
      otherTerms: [],
    },
    tachographLicense: {
      hasLicense: false,
      number: "",
      expirationDate: "",
    },
    workingConditions: {
      shift: false,
      inconvenient: false,
      irregular: false,
      timeoff: false,
    },
    workingHours: {
      options: {
        A_guideInAppendix: false,
        B_guideInAppendix: false,
        A_fullTimeSelected: false,
        A_otherSelected: false,
        A_amount: "",
        B_selected: false,
        C_selected: false,
      },
      A: {
        days: {
          monday: {
            start: "",
            end: "",
          },
          tuesday: {
            start: "",
            end: "",
          },
          wednesday: {
            start: "",
            end: "",
          },
          thursday: {
            start: "",
            end: "",
          },
          friday: {
            start: "",
            end: "",
          },
          saturday: {
            start: "",
            end: "",
          },
          sunday: {
            start: "",
            end: "",
          },
        },
      },
      B: {
        days: {
          monday: "",
          tuesday: "",
          wednesday: "",
          thursday: "",
          friday: "",
          saturday: "",
        },
      },
      C: {
        days: {
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
        },
      },
    },
  },
  mutations: {
    updateCompany(state, company) {
      state.company = company;
    },
    updateContractLocale(state, locale) {
      state.locale.contractLocale = locale;
    },
    updateDrivingLicense(state, license) {
      state.drivingLicense = license;
    },
    updateEducation(state, education) {
      state.education = education;
    },
    updateEmployee(state, employee) {
      state.employee = employee;
    },
    updateEmploymentDetails(state, details) {
      state.employmentDetails = details;
    },
    updateFormLocale(state, locale) {
      state.locale.formLocale = locale;
    },
    updateHealthControl(state, healthControl) {
      state.healthControl = healthControl;
    },
    updateHoliday(state, holiday) {
      state.holiday = holiday;
    },
    updateJobCategories(state, categories) {
      state.jobCategories = categories;
    },
    updateOtherAbsence(state, otherAbsence) {
      state.otherAbsence = otherAbsence;
    },
    updatePension(state, pension) {
      state.pension = pension;
    },
    updateQualifications(state, qualifications) {
      state.qualifications = qualifications;
    },
    updateSalary(state, salary) {
      state.salary = salary;
    },
    updateSpecialSaving(state, specialSaving) {
      state.special_saving = specialSaving;
    },
    updateSalaryPeriod(state, period) {
      state.salaryPeriod = period;
    },
    updateSickness(state, sickness) {
      state.sickness = sickness;
    },
    updateSocialSecurityInstitutions(state, socialSecurityInstitutions) {
      state.socialSecurityInstitutions = socialSecurityInstitutions;
    },
    updateSpecialTerms(state, terms) {
      state.specialTerms = terms;
    },
    updateTachographLicense(state, license) {
      state.tachographLicense = license;
    },
    updateWorkingConditions(state, coditions) {
      state.workingConditions = coditions;
    },
    updateWorkingHoursInputA(state, days) {
      state.workingHours.A.days = days;
    },
    updateWorkingHoursInputB(state, days) {
      state.workingHours.B.days = days;
    },
    updateWorkingHoursInputC(state, days) {
      state.workingHours.C.days = days;
    },
    updateWorkingHoursOptions(state, options) {
      state.workingHours.options = options;
    },
  },
};

export const store = new Vuex.Store({
  modules: {
    contract: contract,
  },
});
